import React, { useEffect, useState } from "react";
import { authorize, authCodeGrant } from "components/Jarvis";
import { Spin } from "antd";
// import EdvLoading from "components/general/loading";

const withAuthenticator = (WrappedComponent) => {
  const Authenticator = (props) => {
    const [init, setInit] = useState(false);

    const initData = async () => {
      let token = localStorage.getItem("access_token");
      if(token) {
        setInit(true);
        return;
      }

      let response = await authCodeGrant();
      console.log("response");
      console.log(response);
      if(response === true) {
        setInit(true);

        // Remove url params
        const url = new URL(window.location.href);
        url.searchParams.delete("state");
        url.searchParams.delete("code");
        window.history.replaceState(null, null, url.toString());
        window.location.reload();
        return;
      }
      response = await authorize();

      // TODO Handle Error (response)
    };

    useEffect(() => {
      initData();
    }, []);

    if(!init) {
      return <Spin className="inset-center" />;
    }
    return <WrappedComponent {...props} />;
  };
  return Authenticator;
};

export default withAuthenticator;
